import { dataBookSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBookSolid = /*#__PURE__*/createIcon(dataBookSolid)
export default IconBookSolid
